import API from './API.ts'

export default {
  //
  // GET
  //
  getPrinters () {
    return API.httpClient.get('printer')
  },

  //
  // POST
  //
  assignPrinter ({ printerId, workstationId }) {
    return API.httpClient.post('printer/assign', {
      printer_id: printerId,
      workstation_id: workstationId
    })
  },
  savePrinter ({ id, name, port, protocol, width, isDefault }) {
    return API.httpClient.post('printer/save', {
      id,
      name,
      port,
      protocol: protocol || 'epson',
      width,
      is_default: isDefault
    })
  },
  deletePrinter ({ printerId }) {
    return API.httpClient.post('printer/delete', {
      id: printerId
    })
  },
  connectSurfboardPrinter ({ terminalSerialNumber, workstationId, name }) {
    return API.httpClient.post('printer/connect-surfboard-printer', {
      terminal_serial_number: terminalSerialNumber,
      workstation_id: workstationId,
      name
    })
  },
  openDrawer (printer) {
    if (printer.port === 'SURF') {
      return this.printOnSurfboard({
        printerId: printer.id,
        content: [{ type: 'open-cash-drawer' }]
      })
    }
    return window.printer.openDrawer(printer.port)
  },
  printOnSurfboard ({ content, printerId }) {
    return API.httpClient.post('printer/print-on-surfboard', {
      content,
      printer_id: printerId
    })
  },
  getActiveReceiptHeaderLogo () {
    return API.httpClient.get('printer/receipt-header/active')
  },
  getReceiptHeaderLogoVariant ({ variant }) {
    return API.httpClient.get(`printer/receipt-header/email/${variant}`, {
      responseType: 'blob'
    })
  },
  selectReceiptHeaderLogo ({ variant }) {
    return API.httpClient.post('printer/receipt-header/select', {
      variant
    })
  },
  clearReceiptHeaderLogo () {
    return API.httpClient.post('printer/receipt-header/clear')
  }
}
